import { List } from 'components';

const WorkExperienceEn: React.FC = () => {
  return (
    <>
      <List>
        <li>
          <strong>02/2018 - 02/2022 | Frontend Developer</strong>
          Digital Studio&nbsp;
          <a href="https://brainst.pro/" target="_blank" rel="noreferrer">
            Brainst
          </a>
          &nbsp;(Project-Based Assignment)
        </li>

        <li>
          <strong>02/2019 - 02/2022 | Frontend Developer</strong>
          Marketing agency for beauty salons and cosmetics&nbsp;
          <a href="https://beautyalliance-marketing.com/" target="_blank" rel="noreferrer">
            Beauty Alliance
          </a>
          &nbsp;(Part-time)
        </li>

        <li>
          <strong>02/2019 - 02/2022 | Frontend Developer</strong>
          Marketing agency&nbsp;
          <a href="https://human-touch.ru/" target="_blank" rel="noreferrer">
            Human-Touch
          </a>
          &nbsp;(Project-Based Assignment)
        </li>

        <li>
          <strong>09/2015 - 01/2018 | Frontend Developer</strong>
          Marketing agency&nbsp;
          <a href="https://mokselle.ru/" target="_blank" rel="noreferrer">
            Mokselle
          </a>
          &nbsp;(Remote)
        </li>
      </List>
    </>
  );
};

export default WorkExperienceEn;
